import React, { useState } from 'react';
import { Plus, X, Users, Star } from 'lucide-react';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function ContactCategoryManager() {
  const {
    currentWorkspace,
    addContactCategory,
    removeContactCategory
  } = useWorkspace();
  const [newCategory, setNewCategory] = useState('');
  const handleAdd = (e: React.FormEvent) => {
    e.preventDefault();
    if (newCategory.trim()) {
      addContactCategory(newCategory.trim());
      setNewCategory('');
    }
  };
  const suggestedCategories = ['Leaders', 'Pastors', 'Influencers', 'Partners', 'VIPs', 'Ambassadors', 'Media', 'Donors'];
  const availableSuggestions = suggestedCategories.filter(cat => !(currentWorkspace.contactCategories || []).includes(cat));
  return <div className="bg-white border border-gray-200 rounded-lg shadow-sm p-4 sm:p-6 space-y-6" data-id="element-72">
      <div data-id="element-73">
        <div className="flex items-center gap-2 mb-1" data-id="element-74">
          <Star className="h-5 w-5 text-amber-500 flex-shrink-0" data-id="element-75" />
          <h3 className="text-lg font-medium text-gray-900" data-id="element-76">
            Contact Categories
          </h3>
        </div>
        <p className="text-sm text-gray-500" data-id="element-77">
          Define categories for high-profile contacts in {currentWorkspace.name}
          . Use these to tag and segment leaders, pastors, influencers, and
          other key contacts.
        </p>
      </div>

      <form onSubmit={handleAdd} className="flex flex-col sm:flex-row gap-3" data-id="element-78">
        <div className="relative flex-1 min-w-0" data-id="element-79">
          <Users className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" data-id="element-80" />
          <input type="text" value={newCategory} onChange={e => setNewCategory(e.target.value)} placeholder="Enter category name (e.g., 'Pastors', 'Influencers')" className="block w-full rounded-md border-gray-300 pl-10 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm" data-id="element-81" />
        </div>
        <button type="submit" disabled={!newCategory.trim()} className="inline-flex items-center justify-center gap-2 px-4 py-2 bg-amber-600 text-white text-sm font-medium rounded-md hover:bg-amber-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap flex-shrink-0" data-id="element-82">
          <Plus className="h-4 w-4 flex-shrink-0" data-id="element-83" />
          <span data-id="element-84">Add Category</span>
        </button>
      </form>

      {/* Quick Add Suggestions */}
      {availableSuggestions.length > 0 && <div className="space-y-2" data-id="element-85">
          <p className="text-xs font-medium text-gray-500 uppercase" data-id="element-86">
            Quick add:
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-87">
            {availableSuggestions.map(cat => <button key={cat} onClick={() => addContactCategory(cat)} className="inline-flex items-center gap-1 px-2.5 py-1 rounded text-xs font-medium bg-gray-100 text-gray-700 hover:bg-amber-50 hover:text-amber-700 border border-gray-200 hover:border-amber-200 transition-colors whitespace-nowrap" data-id="element-88">
                <Plus className="h-3 w-3 flex-shrink-0" data-id="element-89" />
                {cat}
              </button>)}
          </div>
        </div>}

      <div className="space-y-3" data-id="element-90">
        <h4 className="text-sm font-medium text-gray-700" data-id="element-91">Active Categories</h4>
        {(currentWorkspace.contactCategories || []).length === 0 ? <div className="text-sm text-gray-500 italic bg-gray-50 p-4 rounded-md text-center" data-id="element-92">
            No contact categories defined yet. Add one above to start tagging
            high-profile contacts.
          </div> : <div className="flex flex-wrap gap-2" data-id="element-93">
            {(currentWorkspace.contactCategories || []).map(category => <span key={category} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium bg-amber-50 text-amber-800 border border-amber-200" data-id="element-94">
                <Star className="h-3 w-3 flex-shrink-0" data-id="element-95" />
                <span className="truncate max-w-[150px]" data-id="element-96">{category}</span>
                <button onClick={() => removeContactCategory(category)} className="text-amber-500 hover:text-amber-700 focus:outline-none ml-1 flex-shrink-0" title="Remove category" data-id="element-97">
                  <X className="h-3 w-3" data-id="element-98" />
                </button>
              </span>)}
          </div>}
      </div>

      {/* Usage Info */}
      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4" data-id="element-99">
        <h4 className="text-sm font-medium text-blue-900 mb-2" data-id="element-100">
          How to use categories
        </h4>
        <ul className="text-xs text-blue-700 space-y-1" data-id="element-101">
          <li data-id="element-102">
            • Categories sync to Zoho CRM as the{' '}
            <code className="bg-blue-100 px-1 rounded" data-id="element-103">Role_Type</code> field
          </li>
          <li data-id="element-104">
            • Use categories to segment high-profile contacts in campaigns
          </li>
          <li data-id="element-105">
            • Filter audiences by category when exporting to Zoho Campaigns
          </li>
        </ul>
      </div>
    </div>;
}